// ----------------------------------------------------------------------------

function highlight(element: HTMLElement, rowIndex: number, columnIndex: number): void {
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    for (let r = 0; r < element.rows.length; r++) {
        const elRow = element.rows[r];

        for (let c = 0; c < elRow.cells.length; c++) {
            const elColumn = elRow.cells[c];
            const isHighlighted = r <= rowIndex && c <= columnIndex;

            elColumn.toggleClass('highlighted-cell', isHighlighted);
        }
    }
}

// ----------------------------------------------------------------------------

export { highlight };
